if (!window.VariantSelector) {
  class VariantSelector {
    constructor(container) {
      this.container = container;
      this.productCards = container.querySelectorAll(".variant-product-card");
      this.selectedVariant = null;
      this.callbacks = { onVariantSelect: [] };
      this.init();
    }

    init() {
      this.productCards.forEach((card, index) => {
        card.addEventListener("click", () => {
          this.selectVariant(index);
        });
      });

      const selectedCard = this.container.querySelector(".variant-product-card.selected");

      if (!selectedCard && this.productCards.length > 0) {
        this.selectVariant(0);
      } else if (selectedCard) {
        const selectedIndex = Array.from(this.productCards).indexOf(selectedCard);
        this.selectedVariant = selectedIndex;
      }
    }

    selectVariant(index) {
      this.productCards.forEach((card) => {
        card.classList.remove("selected");
      });

      if (this.productCards[index]) {
        this.productCards[index].classList.add("selected");
        this.selectedVariant = index;

        const variantData = this.getVariantData(index);

        this.callbacks.onVariantSelect.forEach((callback) => {
          callback(variantData, index);
        });

        const event = new CustomEvent("variantSelected", {
          detail: {
            variant: variantData,
            index: index,
            element: this.productCards[index],
          },
        });

        this.container.dispatchEvent(event);
      }
    }

    getVariantData(index) {
      const card = this.productCards[index];
      if (!card) return null;

      return {
        title: card.querySelector(".variant-product-title")?.textContent?.trim() || "",
        description: card.querySelector(".variant-product-description")?.textContent?.trim() || "",
        originalPrice: card.querySelector(".variant-original-price")?.textContent?.trim() || "",
        currentPrice: card.querySelector(".variant-current-price")?.textContent?.trim() || "",
        hasBadge: !!card.querySelector(".variant-best-value-badge"),
        badgeText: card.querySelector(".variant-best-value-badge")?.textContent?.trim() || "",
        variantId: card.dataset.variantId || null,
        productId: card.dataset.productId || null,
        variantPrice: card.dataset.variantPrice || null,
        variantComparePrice: card.dataset.variantComparePrice || null,
        variantAvailable: card.dataset.variantAvailable === "true",
      };
    }

    getSelectedVariant() {
      if (this.selectedVariant !== null) {
        return this.getVariantData(this.selectedVariant);
      }
      return null;
    }

    onVariantSelect(callback) {
      this.callbacks.onVariantSelect.push(callback);
    }

    updateVariantColors(colors) {
      if (!colors) return;

      const root = this.container;

      Object.entries(colors).forEach(([property, value]) => {
        if (value) {
          root.style.setProperty(`--variant-${property.replace(/_/g, "-")}`, value);
        }
      });
    }
  }

  // ✅ expose globally
  window.VariantSelector = VariantSelector;
}